// Demo data for meeting briefing room
export const demoMeetingDetails = {
  id: "demo-meeting-1",
  date: new Date().toISOString(),
  medium: "phone",
  duration: "90 minutes"
};

export const demoFormData = {
  members: [
    {
      userId: "demo-user-1",
      firstName: "Thomas",
      lastName: "Borer"
    }
  ]
};

export const demoPipelineData = {
  status: "active",
  stage: "existing_client"
}; 